import styled from 'styled-components';

export const CardContainer = styled.div`
  padding: 16px 0px 32px;
  box-shadow: 0px 1px 2px rgba(128, 138, 157, 0.12), 0px 8px 32px rgba(128, 138, 157, 0.24);
  border-radius: 16px;
  width: 100%;
  height: fit-content;
`;
